// color definitions
export enum PaymentStatusVariant {
  overdue = 'danger',
  unpaid = 'warning',
  paid = 'success',
  asap = 'warning',
  waiting = 'warning',
  claim_rejected = 'danger',
  claim_paid = 'success',
  claim_closed = 'warning'
}

export enum PaymentStatus {
  overdue = 'overdue',
  unpaid = 'unpaid',
  paid = 'paid',
  // next two are used in other situations. Upcoming is overdue or unpaid
  upcoming = 'upcoming',
  past = 'past',
  // this is used for claims payment status
  claim_rejected = 'rejected',
  claim_paid = 'paid',
  claim_closed = 'warning'
}
